import { defineMessages } from 'react-intl';

export const defaultMessages: {
	readonly heading: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly subheading: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly tryItButton: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly writeStatusUpdateLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly writeStatusUpdateDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly connectWorkToolsLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly connectWorkToolsDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly askRovoFindLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly askRovoFindDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly deepResearchLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly deepResearchDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly promptGalleryLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly promptGalleryDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly optionsMenuTitle: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly dismissButtonLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly writeStatusUpdatePrompt: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly deepResearchPrompt: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly oauthErrorMessageTitle: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly oauthErrorGeneric: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly oauthErrorCancelled: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly title: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly previousChecklistCard: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly nextChecklistCard: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly browseAgentsLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly browseAgentsDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly automateWorkLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly automateWorkDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly installExtensionLabel: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
	readonly installExtensionDescription: {
		readonly id: string;
		readonly defaultMessage: string;
		readonly description: string;
	};
} = defineMessages({
	heading: {
		id: 'rovo-expansion-onboarding-checklist.heading',
		defaultMessage: 'Get started working with your AI teammate',
		description: 'Heading name in onboarding checklist',
	},
	subheading: {
		id: 'rovo-expansion-onboarding-checklist.subheading',
		defaultMessage: '{totalSteps} easy steps to become a Rovo Pro',
		description: 'Subheading in onboarding checklist',
	},
	tryItButton: {
		id: 'rovo-expansion-onboarding-checklist.try-it',
		defaultMessage: 'Try it',
		description: 'Primary action on full-width onboarding checklist card',
	},
	writeStatusUpdateLabel: {
		id: 'rovo-expansion-onboarding-checklist.write-status-update',
		defaultMessage: 'Use Rovo to write your status update',
		description: 'Write status update label in onboarding checklist',
	},
	writeStatusUpdateDescription: {
		id: 'rovo-expansion-onboarding-checklist.write-status-update-description',
		defaultMessage: 'Convert your latest Jira activity into one clear, shareable status update',
		description: 'Supporting description for write status update checklist item',
	},
	connectWorkToolsLabel: {
		id: 'rovo-expansion-onboarding-checklist.connect-work-tools',
		defaultMessage: 'Connect Rovo to {appName}',
		description:
			'Connect work tools label in onboarding checklist. appName is the friendly display name of the third-party app, e.g. Google Drive, Salesforce.',
	},
	connectWorkToolsDescription: {
		id: 'rovo-expansion-onboarding-checklist.connect-work-tools-description',
		defaultMessage: 'Connect {appName} so Rovo can search and summarize work across your tools.',
		description: 'Supporting description for connect work tools checklist item',
	},
	askRovoFindLabel: {
		id: 'rovo-expansion-onboarding-checklist.ask-rovo-find',
		defaultMessage: 'Search for related work across your tools',
		description: 'Ask Rovo find label in onboarding checklist',
	},
	askRovoFindDescription: {
		id: 'rovo-expansion-onboarding-checklist.ask-rovo-find-description',
		defaultMessage:
			'Rovo searches across Jira, Confluence, and connected tools to find the work that unblocks you.',
		description: 'Supporting description for ask Rovo find checklist item',
	},
	deepResearchLabel: {
		id: 'rovo-expansion-onboarding-checklist.deep-research',
		defaultMessage: 'Use deep research for complex work',
		description: 'Deep research label in onboarding checklist',
	},
	deepResearchDescription: {
		id: 'rovo-expansion-onboarding-checklist.deep-research-description',
		defaultMessage:
			'Run deep research with Rovo to explore a complex issue and get a research-backed plan to move forward.',
		description: 'Supporting description for deep research checklist item',
	},
	promptGalleryLabel: {
		id: 'rovo-expansion-onboarding-checklist.prompt-gallery',
		defaultMessage: 'Explore the prompt gallery',
		description: 'Prompt gallery label in onboarding checklist',
	},
	promptGalleryDescription: {
		id: 'rovo-expansion-onboarding-checklist.prompt-gallery-description',
		defaultMessage:
			'See a gallery of tested Rovo prompts and use cases you can reuse instead of starting from scratch.',
		description: 'Supporting description for prompt gallery checklist item',
	},
	optionsMenuTitle: {
		id: 'rovo-expansion-onboarding-checklist.options-menu-title',
		defaultMessage: 'Options',
		description: 'Options menu title in onboarding checklist',
	},
	dismissButtonLabel: {
		id: 'rovo-expansion-onboarding-checklist.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button label in onboarding checklist',
	},
	writeStatusUpdatePrompt: {
		id: 'rovo-expansion-onboarding-checklist.write-status-update-prompt',
		defaultMessage: 'Write an update about my week',
		description: 'Write status update prompt in onboarding checklist',
	},
	deepResearchPrompt: {
		id: 'rovo-expansion-onboarding-checklist.deep-research-prompt',
		defaultMessage:
			'Gather and synthesize customer feedback on my site from various channels (emails, calls, surveys, support tickets) to identify common pain points and areas for product enhancement over the past year.',
		description: 'Deep research prompt in onboarding checklist',
	},
	oauthErrorMessageTitle: {
		id: 'rovo-expansion-onboarding-checklist.oauth-error-message-title',
		defaultMessage: 'Error connecting {appName}. Please try again.',
		description: 'Error message title shown when OAuth connection fails',
	},
	oauthErrorGeneric: {
		id: 'rovo-expansion-onboarding-checklist.oauth-error-generic',
		defaultMessage: 'Something went wrong connecting {appName}. Please try again.',
		description: 'Error message shown when OAuth connection fails',
	},
	oauthErrorCancelled: {
		id: 'rovo-expansion-onboarding-checklist.oauth-error-cancelled',
		defaultMessage: 'You cancelled the connection to {appName}. Please try again.',
		description: 'Error message shown when the OAuth connector is cancelled',
	},
	title: {
		id: 'rovo-expansion-onboarding-checklist.title.updated',
		defaultMessage: '{totalSteps} Quick tips to power up your work with AI',
		description: 'Title in onboarding checklist',
	},
	previousChecklistCard: {
		id: 'rovo-expansion-onboarding-checklist.previous-card',
		defaultMessage: 'Previous tip',
		description: 'Label for carousel control to show the previous onboarding checklist tip',
	},
	nextChecklistCard: {
		id: 'rovo-expansion-onboarding-checklist.next-card',
		defaultMessage: 'Next tip',
		description: 'Label for carousel control to show the next onboarding checklist tip',
	},
	browseAgentsLabel: {
		id: 'rovo-expansion-onboarding-checklist.browse-agents',
		defaultMessage: 'Browse agents to handle specialized work',
		description: 'Browse agents label in onboarding checklist',
	},
	browseAgentsDescription: {
		id: 'rovo-expansion-onboarding-checklist.browse-agents-description',
		defaultMessage:
			"Build or use Rovo agents that know your team's context, can answer questions, write content, or take action.",
		description: 'Supporting description for browse agents checklist item',
	},
	automateWorkLabel: {
		id: 'rovo-expansion-onboarding-checklist.automate-work',
		defaultMessage: 'Automate repetitive work with Rovo-powered flows',
		description: 'Automate work label in onboarding checklist',
	},
	automateWorkDescription: {
		id: 'rovo-expansion-onboarding-checklist.automate-work-description',
		defaultMessage:
			"Get Rovo to automatically update key work item details like fields and labels, so you don't have to.",
		description: 'Supporting description for automate work checklist item',
	},
	installExtensionLabel: {
		id: 'rovo-expansion-onboarding-checklist.install-extension',
		defaultMessage: 'Install the Chrome Extension',
		description: 'Install chrome extension label in onboarding checklist',
	},
	installExtensionDescription: {
		id: 'rovo-expansion-onboarding-checklist.install-extension-description',
		defaultMessage: 'Access Rovo from everywhere you work on the web.',
		description: 'Supporting description for the install chrome extension checklist item',
	},
} as const);
